import React from 'react';
import { Text } from '@shopify/polaris';

import BatchGrid from './BatchGrid';
import { UI_COLORS } from '../../constants';

// Compact cart map for a single tote position, built on the warehouse
// app's BatchGrid - replaces "Row X, Column Y" text in tables and
// headers. Falls back to the text when the cart dimensions or the
// position itself are missing.
const PositionGrid = ({ rows, columns, row, column, color = UI_COLORS.cyan }) => {
  if (!rows || !columns || !row || !column) {
    return <Text as="span" variant="bodySm">{row && column ? `R${row} C${column}` : '-'}</Text>;
  }

  return (
    <BatchGrid
      totalRows={rows}
      totalColumns={columns}
      toteSize={10}
      gap={2}
      highlightedTotes={[{ row, column, color }]}
      ariaLabel={`Tote at row ${row}, column ${column}`}
    />
  );
};

export default PositionGrid;
